import React, { useState } from 'react'
import _ from 'lodash'

import { Button, Divider } from '@material-ui/core'
import { formatBRL, formatToCurrency } from 'utils/functions'

import { Alert } from '@material-ui/lab'
import { ArrowDropDown, ArrowRight } from '@material-ui/icons'
import NoDataFoundMessage from 'ui/views/Home/NoDataFoundMessage'
import colors from 'utils/constants/colors'

import Container from './styles'
import { sectionsInfo } from './sectionsInfo'

const SingleTableIncome = ({ irDeclaration, sectionId, isExportingPDF }) => {
  const incomeData = irDeclaration[sectionId]
  const [showIncomeItems, setShowIncomeItems] = useState(false)
  const sectionColumns = sectionsInfo[sectionId]?.columns
  const regularColumns = _.omitBy(
    sectionColumns,
    (col) => col.type === 'inner_table' || col.isHorizontal,
  )
  const horizontalColumns = _.pickBy(sectionColumns, (col) => col.isHorizontal)

  const getTrClassBasedOnIndex = (index) => (index % 2 === 1 ? 'tr-zebra' : null)

  const renderTotals = () => {
    const totalColumns = _.pickBy(sectionColumns, (col) => !_.isEmpty(col.total_value_column))
    const totalValues = incomeData?.total_values || {}
    const hasScalarTotals = _.has(totalValues, 'amount') && _.has(totalValues, 'valid')
    const allValuesValid = hasScalarTotals
      ? totalValues.valid
      : _.every(totalValues, (col) => col.valid)

    if (_.isEmpty(totalColumns) && !hasScalarTotals) {
      return null
    }

    return (
      <div className="values-data-container">
        {!hasScalarTotals &&
          _.map(totalColumns, (col, key) => {
            return (
              <p key={key}>
                <span>{`${col.total_value_column}: `}</span>
                <span
                  style={{ color: totalValues[key]?.valid ? null : colors.red }}
                  className="total-correct"
                >
                  {formatBRL(totalValues[key]?.amount)}
                </span>
              </p>
            )
          })}

        {hasScalarTotals && (
          <p>
            <span>{'Valor Total: '}</span>
            <span
              style={{ color: totalValues.valid ? null : colors.red }}
              className="total-correct"
            >
              {formatBRL(totalValues.amount)}
            </span>
          </p>
        )}

        { allValuesValid != null && (
          <p>
            <span>{'Valores Corretos: '}</span>
            <span style={{ color: allValuesValid ? null : colors.red }} className="total-correct">
              {allValuesValid ? 'SIM' : 'NÃO'}
            </span>
          </p>
        )}
      </div>
    )
  }

  const createRowStyle = (row, index, currentPageHasProblems) => ({
    padding: '20px 0',
    borderLeft: currentPageHasProblems && index === 0 ? `1px solid ${colors.red}` : null,
    borderRight:
      currentPageHasProblems && index === row.length - 1 ? `1px solid ${colors.red}` : null,
  })

  const formatValue = (dataType, value) => {
    if (value == null) {
      return '-'
    }
    if (dataType === 'boolean') {
      return value ? 'Sim' : 'Não'
    }
    if (dataType === 'currency') {
      return formatToCurrency(value)
    }
    return value
  }

  const renderColumnCell = (k, v, customColumnsMetadata = null) => {
    const columns = _.isEmpty(customColumnsMetadata) ? sectionColumns : customColumnsMetadata
    if (!_.has(columns, k)) {
      return null
    }
    return formatValue(columns[k]?.type, v)
  }
  const renderRowColumns = (row, currentPageHasProblems, customColumnsMetadata = null) => {
    const entries = Object.entries(row)
    return entries.map(([k, v], index) => {
      if (!_.has(customColumnsMetadata, k)) {
        return null
      }
      return (
        <td key={k} style={createRowStyle(row, index, currentPageHasProblems)}>
          {renderColumnCell(k, v, customColumnsMetadata)}
        </td>
      )
    })
  }

  const renderHorizontalColumns = (row, index) => {
    if (_.isEmpty(horizontalColumns)) {
      return null
    }
    const maxColumnsPerRow = _.size(regularColumns)
    const metaColumnChunks = _.chunk(_.entries(horizontalColumns), maxColumnsPerRow)
    return _.map(metaColumnChunks, (metaColumnsChunk) => {
      const chunk = _.fromPairs(metaColumnsChunk)
      const items = _.pickBy(row, (_rowCol, key) => _.has(chunk, key))
      if (_.isEmpty(metaColumnsChunk)) {
        return null
      }
      return (
        <tr className={getTrClassBasedOnIndex(index)} key={Object.keys(items).join()}>
          {_.map(items, (item, key) => {
            return (
              <td key={key}>
                {`${horizontalColumns[key].name}: ${formatValue(
                  horizontalColumns[key].type,
                  item,
                )}`}
              </td>
            )
          })}
        </tr>
      )
    })
  }

  const renderInnerTable = (row, index) => {
    const colWithInnerTableMetadataObject = _.pickBy(
      sectionColumns,
      (c) => c.type === 'inner_table',
    )
    if (_.isEmpty(colWithInnerTableMetadataObject)) {
      return null
    }

    const [colId, colWithInnerTableMetadata] = _.entries(colWithInnerTableMetadataObject)[0] || []

    const colWithInnerTable = row[colId]
    if (_.isEmpty(colWithInnerTable)) {
      return null
    }

    return (
      <tr className={getTrClassBasedOnIndex(index)}>
        <td colSpan={_.size(regularColumns)}>
          <div style={{ marginTop: 10 }}>
            <table className="inner-table">
              <caption>
                <h4>{colWithInnerTableMetadata.name}</h4>
              </caption>
              <thead>
                <tr>
                  {_.map(colWithInnerTableMetadata.columns, (c) => (
                    <th key={c.name}>{c.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {_.map(colWithInnerTable.items, (r) => (
                  <tr key={Object.values(r).join()} className={getTrClassBasedOnIndex(index)}>
                    {renderRowColumns(r, null, colWithInnerTableMetadata.columns)}
                  </tr>
                ))}
                {_.isEmpty(colWithInnerTable.total) ? null : (
                  <tr className={getTrClassBasedOnIndex(index)}>
                    <td>
                      <b>TOTAL</b>
                    </td>
                    <td>{formatBRL(colWithInnerTable.total.amount)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    )
  }

  const renderSectionItems = () => {
    const { items } = incomeData
    const totalPages = irDeclaration?.total_pages

    if (_.isEmpty(items)) return null

    const pages = _.groupBy(items, 'page')
    return (
      <div className="table-container">
        <table className="main-table">
          <thead>
            <tr>
              {_.map(regularColumns, (col, key) => (
                <th key={key}>{col.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {_.map(pages, (pageRows) => {
              const currentPageNum = pageRows[0]?.page
              const currentPageHasProblems = false // subsectionItems.pages_with_problems.includes(currentPageNum)
              return (
                <React.Fragment key={pageRows[0]?.id}>
                  {sectionsInfo[sectionId]?.show_pages !== false && (
                    <tr
                      style={{
                        backgroundColor: '#fff',
                      }}
                    >
                      <td
                        style={{
                          margin: '10px 0',
                          textAlign: 'left',
                          borderLeft: currentPageHasProblems ? `1px solid ${colors.red}` : null,
                          borderRight: currentPageHasProblems ? `1px solid ${colors.red}` : null,
                        }}
                        colSpan={8}
                      >
                        <span style={{ fontSize: '1.34rem' }}>
                          {`Página ${currentPageNum} ${totalPages ? `de ${totalPages}` : ''}`}

                          {currentPageHasProblems && (
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 3,
                                width: '100%',
                                margin: '5px 0',
                              }}
                            >
                              <Alert severity="error" style={{ width: '100%' }}>
                                Houve um erro na extração de dados dessa página. Um ou mais itens
                                podem estar inválidos, repetidos ou faltando.
                              </Alert>
                            </span>
                          )}
                        </span>
                      </td>
                    </tr>
                  )}
                  {_.map(pageRows, (row, index) => (
                    <React.Fragment key={Object.values(row).join()}>
                      <tr className={getTrClassBasedOnIndex(index)}>
                        {renderRowColumns(row, currentPageHasProblems, regularColumns)}
                      </tr>
                      {renderHorizontalColumns(row, index)}
                      {renderInnerTable(row, index)}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  const renderSection = () => {
    if (_.isEmpty(incomeData)) {
      return null
    }

    return (
      !_.isEmpty(incomeData.items) && (
      <div className="values-files-container">
        <Button
          startIcon={showIncomeItems ? <ArrowDropDown /> : <ArrowRight />}
          onClick={() => setShowIncomeItems(!showIncomeItems)}
        >
          <strong style={{ fontSize: '1.34rem' }}>
            {showIncomeItems ? 'Esconder itens' : 'Exibir itens'}
          </strong>
        </Button>

          {(showIncomeItems || isExportingPDF) && (
            <div className="values-file-container">
              <div className="text-container">
                {/* <p>
                  <span>Todos os itens estão corretos:</span>
                  {' '}
                  <span
                    className="file-correct"
                    style={{
                      color: _.isEmpty(incomeData.pages_with_problems) ? null : 'rgb(255, 23, 68)',
                    }}
                  >
                    {booleanToText(_.isEmpty(incomeData.pages_with_problems))}
                  </span>
                </p> */}
              </div>
              <div key={incomeData.name}>
                {renderSectionItems()}

                <Divider />
                <br />
              </div>
            </div>
          )}
      </div>
        )

    )
  }

  return (
    <Container>
      <h2>{sectionsInfo[sectionId]?.name}</h2>
      {_.isEmpty(incomeData) ? (
        <NoDataFoundMessage />
      ) : (
        <div>
          {renderTotals()}
          {renderSection()}
        </div>
      )}
    </Container>
  )
}

export default SingleTableIncome
